import { z } from "zod";

/**
 * Search-param schema for the admin booking detail route.
 * `tab` drives the `UrlTabs` selection; `.catch` (rather than `.default`)
 * makes stale or hand-edited `?tab=` values fall back instead of throwing.
 */
export const bookingDetailSearchSchema = z.object({
	tab: z.enum(["general", "invoice"]).catch("general"),
});
